import { render, staticRenderFns } from "./ServiciosListado.vue?vue&type=template&id=4bf04f00"
import script from "./ServiciosListado.vue?vue&type=script&lang=js"
export * from "./ServiciosListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports